import { createSlice } from "@reduxjs/toolkit";
import authInitialState from "@/redux/slice/auth/initialState";
import AuthReducer from "@/redux/slice/auth/reducers/actionReducers";
import asyncAuthReducers from "@/redux/slice/auth/reducers/extraReducers";

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: AuthReducer,
  extraReducers: asyncAuthReducers,
});

export const {
  updateCurrentPatient,
  updatePatientList,
  updateSSOToken,
  updateAuthToken,
  updateCurrentPatientId,
  updateAskForConsent,
  updateUserConsent,
  updateSignedInState,
  updateSignInError,
  updateUserType,
  updateNewUser,
  updateTokenRefresh,
  updateTokenRecievedFetchPatients,
  updateUserCorporateTag,
  updateUserOnboarded,
  handleOpenLoginModal,
  handleSegmentInfo,
} = authSlice.actions;

export default authSlice.reducer;
